import {Marketer} from '../models/Marketer';
import {MarketerAPIDataSource} from '../api/MarketerAPIDataSource';

export class GetAllMarketersWithoutPaginationUseCase {
  async execute (): Promise<{ items: Marketer[]; pagination?: any }> {
    return MarketerAPIDataSource.getAllWithoutPagination();
  }
}
